export function HHomeInsuranceIcon({
  className,
}: {
  className?: string;
}): JSX.Element {
  return (
    <svg
      width="28"
      height="24"
      viewBox="0 0 28 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M4.55566 21.3332V8.20485L1.166 10.7229L0.555664 9.91785L13.889 -0.0078125L27.248 9.91785L26.6377 10.7229L13.889 1.26919L5.58133 7.46652V20.3075H10.2633V21.3332H4.55566ZM17.6147 23.9999L13.1147 19.4999L13.848 18.7845L17.6147 22.5589L25.1813 15.0255L25.889 15.7332L17.6147 23.9999Z" />
    </svg>
  );
}
